module.exports = __webpack_public_path__ + "img/Grid-Strat_Demo.59574b72.jpg";